import { Injectable } from '@angular/core';
import { IAdjustmentTypeService } from './iadjustment-type.service';
import { AdjustmentType } from './adjustment-type.model';
import { ApiService, ApiCacheOptions, PagedResultGeneric } from '../../../shared/index';
import { AdjustmentTypeSearchDto } from './dto/adjustment-type-search.dto';

@Injectable({ providedIn: 'root' })
export class AdjustmentTypeService implements IAdjustmentTypeService {
  public _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public search(dto: AdjustmentTypeSearchDto, forceRefresh?: boolean): Promise<PagedResultGeneric<AdjustmentType>> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged('AdjustmentTypes/Search', dto, cacheOptions, true);
  }

  public create(dto: AdjustmentType): Promise<number> {
    return this._apiService.post('AdjustmentTypes', dto, true);
  }

  public update(dto: AdjustmentType): Promise<void> {
    return this._apiService.put(`AdjustmentType/${dto.AdjustmentTypeId}`, dto, true);
  }

  public delete(id: number): Promise<void> {
    return this._apiService.delete(`AdjustmentType/${id}`, true);
  }

  public getAdjustmentTypes = (): Promise<Array<AdjustmentType>> => {
    return this._apiService.get('AdjustmentTypes/Active', this._cacheOptions).then((data: Array<AdjustmentType>) => {
      return Promise.resolve(data);
    });
  };

  public getAdjustmentType = (adjustmentTypeId: number): Promise<AdjustmentType> => {
    return this._apiService.get('AdjustmentType/' + adjustmentTypeId.toString(), this._cacheOptions).then((data: AdjustmentType) => {
      return Promise.resolve(data);
    });
  };

  public getAdjustmentTypesForAccountingPackage = (accountingPackageId: number): Promise<Array<AdjustmentType>> => {
    return this._apiService
      .get('AdjustmentTypes/AccountingPackage/' + accountingPackageId.toString(), this._cacheOptions)
      .then((data: Array<AdjustmentType>) => {
        return Promise.resolve(data);
      });
  };

  public getAdjustmentTypesForRevenueItem = (revenueItemNum: number): Promise<Array<AdjustmentType>> => {
    return this._apiService
      .get('AdjustmentTypes/RevenueItem/' + revenueItemNum.toString(), this._cacheOptions)
      .then((data: Array<AdjustmentType>) => {
        return Promise.resolve(data);
      });
  };

  public getAdjustmentTypesForPaymentType = (paymentTypeId: number): Promise<Array<AdjustmentType>> => {
    return this._apiService
      .get('AdjustmentTypes/PaymentType/' + paymentTypeId.toString(), this._cacheOptions)
      .then((data: Array<AdjustmentType>) => {
        return Promise.resolve(data);
      });
  };
}
